import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import FAQ_LIST from '@/util/FaQData.yaml';

@Component({
    components: AllComponents(),
})
export default class FaQ extends Mixins(CommonView) {
    public list = FAQ_LIST;

    public created() {
    }
}
